import jwt_decode from "jwt-decode";

const User = {
  id: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.id || false;
    } catch (error) {
      return false;
    }
  },
  nome: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.nome || false;
    } catch (error) {
      return false;
    }
  },
  email: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.email || false;
    } catch (error) {
      return false;
    }
  },
  perfil: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.perfil || false;
    } catch (error) {
      return false;
    }
  },
  dt_termino: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.termino || false;
    } catch (error) {
      return false;
    }
  },
  progressao: function () {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;

      const decoded = jwt_decode(token);

      return decoded.progressao || false;
    } catch (error) {
      return false;
    }
  },
};

export default User;